<template>
  <div v-loading="loading" class="stat-card green-top">
    <div class="card-header">CHỈ SỐ TƯƠNG TÁC KHÔNG GIAN VĂN HÓA</div>
    <div class="interaction-metrics">
      <div class="metric-item">
        <span class="label">Lượt xem</span>
        <span class="num">182.600</span>
      </div>
      <div class="metric-item">
        <span class="label">Yêu thích</span>
        <span class="num">{{ likeCount | numberWithDelimiter }}</span>
      </div>
      <div class="metric-item">
        <span class="label">Đánh giá</span>
        <span class="num rating">⭐ {{ rateAvg | numberWithDelimiter('.', ',', 1) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { recordUtilsCount } from '@/services/count'
import TYPE from '@/data/type'

export default {
  name: 'CulturalSpaceInteractionCard',
  filters: {
    numberWithDelimiter(val, decimalSeparator, thousandsSeparator, precision) {
      if (val === undefined || val === null) return '0'
      if (precision !== undefined) {
        return val.toFixed(precision).replace('.', decimalSeparator || ',')
      }
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator || '.')
    }
  },
  data() {
    return {
      likeCount: 0,
      rateAvg: 0,
      loading: false
    }
  },
  computed: {
    ...mapGetters(['language']),
    culturalSpaces() {
      return TYPE.PLACES.filter((item) => item.group_type === 'cultural_space')
    }
  },
  watch: {
    language() {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      const targetTypes = this.culturalSpaces.map(item => item.value)

      const items = []
      targetTypes.forEach(type => {
        items.push({
          table_key: 'like',
          filters: { object_type: 'place' },
          object_filters: { place_type: type },
          query_id: `${type}_like`
        })
        items.push({
          table_key: 'rate',
          filters: { object_type: 'place' },
          object_filters: { place_type: type },
          aggregate: 'avg:rate_value',
          query_id: `${type}_rate`
        })
      })

      recordUtilsCount({ items })
        .then((response) => {
          const counts = (response && response.counts) || {}
          let totalLikes = 0
          let totalRates = 0
          let rateCount = 0

          targetTypes.forEach(type => {
            const likeCount = counts[`like_${type}_like`] || 0
            const rateVal = counts[`rate_${type}_rate`] || 0

            totalLikes += likeCount
            if (rateVal > 0) {
              totalRates += rateVal
              rateCount++
            }
          })

          this.likeCount = totalLikes
          this.rateAvg = rateCount ? totalRates / rateCount : 0
        })
        .catch((err) => {
          console.error('Failed to fetch cultural space interactions', err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.stat-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-top: 4px solid #eaeaea;
  min-height: 125px;
  transition: all 0.3s ease;
  box-sizing: border-box;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  }

  &.green-top { border-top-color: #2ecc71; }

  .card-header {
    font-size: 12px;
    font-weight: 700;
    color: #8c8c8c;
    margin-bottom: 12px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }

  .interaction-metrics {
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    padding-top: 8px;
    border-top: 1px dashed #f1f1f1;
    gap: 8px;

    .metric-item {
      display: flex;
      flex-direction: column;
      flex: 1;

      .label {
        font-size: 11px;
        color: #7f8c8d;
        font-weight: 600;
        margin-bottom: 4px;
      }

      .num {
        font-size: 14px;
        font-weight: 750;
        color: #2c3e50;

        &.rating {
          color: #f39c12;
        }
      }
    }
  }
}
</style>
